// src/components/Control/Features/VisionOverlay.tsx
// Рамки распознанного (robot/<id>/vision/detections) поверх видео с камеры:
// предметы, знакомые лица, знаки. Люди — в PersonOverlay.
// Координаты рамок — доли кадра 0..1; кадр 4:3, как и окно видео.
import React, { useState } from 'react';
import * as zenoh from '@eclipse-zenoh/zenoh-ts';
import { useZenohJson } from '../../../hooks/useZenohSubscription';
import { useTick } from '../../../hooks/useTick';
import { Detections } from '../../../types/features';

const VisionOverlay: React.FC<{ zenohSession: zenoh.Session | null; robotId: string }> = ({ zenohSession, robotId }) => {
  const [det, setDet] = useState<(Detections & { at: number }) | null>(null);
  useTick(1000);
  useZenohJson<Detections>(zenohSession, `robot/${robotId}/vision/detections`, msg => setDet({ ...msg, at: Date.now() }));

  if (!det || Date.now() - det.at > 2000) return null;
  const style = (b: number[]) => ({
    left: `${b[0] * 100}%`, top: `${b[1] * 100}%`, width: `${(b[2] - b[0]) * 100}%`, height: `${(b[3] - b[1]) * 100}%`,
  });
  return (
    <div className="vision-overlay">
      {/* Людей с позой и именами рисует PersonOverlay (person_node) */}
      {det.objects.filter(o => o.label !== 'person').map((o, i) => (
        <div key={`o${i}`} className="box" style={style(o.box)}>
          <span>
            {o.label_ru} {Math.round(o.score * 100)}%
          </span>
        </div>
      ))}
      {det.faces.filter(f => f.name).map((f, i) => (
        <div key={`f${i}`} className="box face" style={style(f.box)} />
      ))}
      {det.signs.map((s, i) => (
        <div key={`s${i}`} className="box sign" style={style(s.box)}>
          <span>{s.kind === 'qr' ? `QR: ${s.text}` : `маркер ${s.text}`}</span>
        </div>
      ))}
    </div>
  );
};

export default VisionOverlay;
